import { useEffect, useState, RefObject } from 'react';

export const useImageSelection = (
  editorRef: RefObject<HTMLDivElement | null>,
) => {
  const [selectedImage, setSelectedImage] = useState<HTMLImageElement | null>(
    null,
  );

  useEffect(() => {
    const handleImageClick = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'IMG') {
        e.preventDefault();
        e.stopPropagation();
        setSelectedImage(target as HTMLImageElement);
      } else if (!target.closest('.image-resize-overlay')) {
        setSelectedImage(null);
      }
    };

    const editorElement = editorRef.current?.querySelector('.rsw-ce');
    if (editorElement) {
      editorElement.addEventListener('click', handleImageClick);
      return () => editorElement.removeEventListener('click', handleImageClick);
    }
  }, [editorRef]);

  return { selectedImage, setSelectedImage };
};
